import {SetProperties} from "@/models/SetProperties";

export class MessageForFormData extends SetProperties{
  constructor() {
    super()
    this.fullName = null
    this.email = null
    this.questionBody = null
  }

  getForAPI() {
    return {
      fullName: this.fullName,
      email: this.email,
      questionBody: this.questionBody,
    }
  }
}
